import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
  NormalButton,
  NormalDate,
  NormalTable,
  NormalMultiSelect,
} from "component/common";

import { getCommonApi, commonCreateApi } from "redux/actions/common";
import "../style.scss";
import { history } from "helpers";
import download from "assets/images/reports/download.png";
import print from "assets/images/reports/print.png";
import ReactPaginate from "react-paginate";
import moment from "moment";

export class CollectionOutletClass extends Component {
  state = {
    formFields: {
      projectTitle: "",
      projectDesc: "",
      status: "",
      custName: "",

      contactName: "",
      contactNumber: "",
    },
    SiteSelectionOption: [],
    SiteSelection: [],
    isMounted: true,
    selectedInvoice: null,
    from_Date: new Date(),
    paymentTransactions: [],
    to_Date: new Date(),
    // scheduleOptions: [],
    reports: [],
    ReportTable: [],
    projectList: [],
    invoice: [],
    invoiceref: [],
    statusOption: [],
    hide: true,
    total: 0,
    showPrint: true,
    is_loading: true,
    treatmentListHeader: [
      // {
      //   label: "Payment type",
      //   className: "text-center",
      // },
      // {
      //   label: "Payment date",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Issued by",
      //   className: "text-center",
      // },
      // {
      //   label: "Invoice Ref",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer Ref.",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Payment by others",
      //   className: " align-items-center justify-content-center",
      // },
      // {
      //   label: "TAXES",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Bank charges",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Receivables",
      //   className: "align-items-center justify-content-center",
      // },
    ],
    active: false,
    currentValue: 0,
    CollectionOutlet: [],
    perPage: 10,
    payDate: [],
    currentPage: 1,
    isLoading: false,

    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      {
        to: this.props.location.pathname,
        label: "Quotation",
        id: "Quotation",
      },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
    PayModeOption: [],
    PayMode: [],
  };
  // }
  componentWillUnmount() {
    this.state.isMounted = false;
  }
  handleDatePick = ({ target: { value, name } }) => {
    let { from_Date, to_Date } = this.state;

    if (name == "to_Date") {
      to_Date = value;
      this.setState({ to_Date });
    }

    if (name == "from_Date") {
      from_Date = value;
      this.setState({ from_Date });
    }
    this.setState({
      from_Date,
      to_Date,
    });
  };

  handleInvoiceRef(item) {
    this.props.getCommonApi(`receiptpdf/?sa_transacno=${item}`).then((res) => {
      console.log(res.data, "result");

      this.setState({
        invoice: res.data,
      });
      const { invoice } = this.state;
      window.open(invoice, "_blank");
    });
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.Selected_data();
    this.getdefaultSiteList();
  }

  Selected_data() {
    this.props.getCommonApi(`listpaytable/`).then(async (res) => {
      console.log(res, "PayModeOption");
      let PayModeOption = [];
      this.setState({
        PayModeOption: res.data?.map((e) => {
          return { label: e.name, value: e.code };
        }),
      });

      console.log(PayModeOption.itemcode, "paymode");
    });
  }
  updateState = async (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  onChange = (e) => {
    this.updateState({ [e.target.name]: e.target.value });
  };
  handleMultiSiteSelection = (data = []) => {
    let { SiteSelection } = this.state;
    SiteSelection = data;
    this.setState({ SiteSelection });
  };
  handleMultiPayModeSelection = (data = []) => {
    let { PayMode } = this.state;
    PayMode = data;
    this.setState({ PayMode });
  };

  getdefaultSiteList = async () => {
    let { SiteSelectionOption, SiteSelection } = this.state;
    this.props.getCommonApi(`sitelisting/`).then(async (res) => {
      console.log(res, "SiteSelectionOption");
      let SiteSelectionOption = [];
      this.setState({
        SiteSelectionOption: res.data?.map((e) => {
          return { label: e.itemdesc, value: e.itemcode };
        }),
      });

      let { data, status } = res;
    });
  };

  handleViewReport(currentPage = 1) {
    this.setState({
      isLoading: true,
    });
    let {
      from_Date,
      to_Date,
      CollectionOutlet,
      SiteSelection,
      PayMode,
      ReportTable,
      paymentTransactions,
      payDate,
      invoiceref,
    } = this.state;
    try {
      const data = {
        from_date: moment(from_Date).format("YYYY-MM-DD"),
        to_date: moment(to_Date).format("YYYY-MM-DD"),
        report_title: "Collection By Outlet",
        site_code:
          this.state.SiteSelection.length > 0
            ? this.state.SiteSelection.map((e) => e.value).join(",")
            : "",
        pay_code:
          this.state.PayMode.length > 0
            ? this.state.PayMode.map((e) => e.value).join(",")
            : "",

        limit: 10,
        page: currentPage,
      };
      this.props.commonCreateApi(`collectionbyoutlet/`, data).then((res) => {
        console.log(res, "hdr");
        console.log(invoiceref, " invoiceref");
        this.setState({
          CollectionOutlet: res.company_header,
          ReportTable: res.data.dataList,
          invoiceref: res.data.dataList.map((e) => e.sa_transacno),
          paymentTransactions: res.data.dataList,
          payDate: res.data.dataList[0].payDate,
        });
        // let temp = res.data.dataList[0];
        console.log(invoiceref, "invoiceref");
        console.log(this.ReportTable, "reportstable");
        console.log(this.state.paymentTransactions, "trans");
        // console.log(this.state.payDate, "tempss");
      });
      this.setState({
        isLoading: false,
        CollectionOutlet,
        ReportTable,
        invoiceref,
        paymentTransactions,
        payDate,
      });
    } catch (e) {
      console.log(e, "topupgetcombinelog");
    }
  }

  onSubmit() {
    this.handleViewReport();
  }

  handlePageClick = (e) => {
    console.log(e.selected, "e.selected");
    this.handleViewReport(e.selected + 1);
  };
  Print = () => {
    let printContents = document.getElementById("printablediv");
    this.setState({ showPrint: false });
    window.print();
  };
  render() {
    let {
      ReportTable,
      CollectionOutlet,
      payTypes,
      isLoading,
      paymentTransactions,
    } = this.state;
    const groupedData = {};
    paymentTransactions.forEach((item) => {
      const { siteName, payTypes, payDate, amt, taxes, bankCharges, total } =
        item;
      if (!groupedData[siteName]) {
        groupedData[siteName] = {};
      }
      if (!groupedData[siteName][payTypes]) {
        groupedData[siteName][payTypes] = {
          items: [],
          totalAmt: 0,
          totalTaxes: 0,
          totalBankCharges: 0,
          total: 0,
        };
      }
      groupedData[siteName][payTypes].items.push(item);
      groupedData[siteName][payTypes].totalAmt += parseFloat(amt);
      groupedData[siteName][payTypes].totalTaxes += parseFloat(taxes);
      groupedData[siteName][payTypes].totalBankCharges +=
        parseFloat(bankCharges) || 0;
      groupedData[siteName][payTypes].total += parseFloat(total);
    });

    // Rendering the grouped data
    const siteNameKeys = Object.keys(groupedData);
    return (
      <div className="col-12">
        <div className="container-fluid pb-5 bg-white px-md-5 my-3">
          <div className="py-5 ">
            <div className="col-md-12">
              <p className="fs-16">
                <span className="font-weight-bold px-1 ">HOME/REPORTS/</span>
                COLLECTION BY OUTLET
              </p>
              <h1 className="my-4 reports-heading">Collection By Outlet</h1>
              <p className="font-weight-normal fs-16">Total = (Sales - Void)</p>
            </div>

            <div className=" my-3">
              <div className="row">
                <div className="mt-3 col-lg-3  col-sm-6 ">
                  <span>{"From Date*"}</span>
                  <div className="input-group">
                    <NormalDate
                      value={this.state.from_Date}
                      name="from_Date"
                      showYearDropdown={true}
                      onChange={this.handleDatePick}
                      dateFormat="dd/MM/yyyy "
                    />
                  </div>
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span>{"To Date*"}</span>
                  <div className="input-group">
                    <NormalDate
                      value={this.state.to_Date}
                      name="to_Date"
                      showYearDropdown={true}
                      dateFormat="dd/MM/yyyy"
                      type="date"
                      onChange={this.handleDatePick}
                    />
                  </div>
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span>{"Site Selection"}</span>
                  <NormalMultiSelect
                    handleMultiSelect={this.handleMultiSiteSelection}
                    options={this.state.SiteSelectionOption}
                    value={this.state.SiteSelection}
                    name="SiteSelection"
                  />
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span className="text-black">{"Pay Mode"}</span>

                  <NormalMultiSelect
                    handleMultiSelect={this.handleMultiPayModeSelection}
                    options={this.state.PayModeOption}
                    value={this.state.PayMode}
                    name="PayMode"
                  />
                </div>
                <div className="my-4 pt-3 col-md-3 col-12">
                  <NormalButton
                    mainbg={true}
                    label={"View Report"}
                    onClick={() => this.onSubmit()}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            {isLoading ? (
              <tr>
                {/* <td colSpan="8">
                  <div class="d-flex mt-5 align-items-center justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td> */}
                <h5>No Data Available</h5>
              </tr>
            ) : ReportTable && ReportTable.length > 0 ? (
              <div className="report">
                <div className=" border px-md-5 py-4 mx-md-4">
                  <div>
                    <div className="row border-md my-3 p-1">
                      <div className="col-lg-2 col-sm-5">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={this.state.pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={1}
                          onPageChange={(event) => this.handlePageClick(event)}
                          containerClassName={"pagination"}
                          subContainerClassName={"pages pagination"}
                          activeClassName={"active"}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-2  border-left border-right text-center mt-2">
                        <button
                          id="print"
                          onClick={() => this.printPDF()}
                          className="pointer bg-white border-0"
                        >
                          <p>
                            <img
                              src={download}
                              alt="download"
                              className="mx-1"
                            />
                          </p>{" "}
                        </button>
                      </div>
                      <div className="col-lg-2 col-sm-2 mt-1 col-6">
                        {" "}
                        <div>
                          <NormalButton
                            buttonClass={"print"}
                            mainbg={true}
                            label="print"
                            className="pointer bg-white border-0"
                            onClick={() =>
                              history.push({
                                pathname:
                                  "/admin/collectionbyoutlet/printreport",
                                state: {
                                  CollectionOutlet: this.state.CollectionOutlet,
                                  paymentTransactions:
                                    this.state.paymentTransactions,
                                  payDate: this.state.payDate,
                                  // from_date: moment(
                                  //   this.state.from_Date
                                  // ).format("YYYY-MM-DD"),

                                  // to_date: moment(this.state.to_Date).format(
                                  //   "YYYY-MM-DD"
                                  // ),

                                  // report_title: "Collection By Outlet",

                                  // site_code: this.state.SiteSelection.map(
                                  //   (e) => e.value
                                  // ).join(","),

                                  // pay_code: this.state.PayMode.map(
                                  //   (e) => e.value
                                  // ).join(","),

                                  // limit: 10,

                                  // page: this.state.currentPage,
                                },
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <tr>
                        <td colSpan="8">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <div id="printablediv">
                        <h3 className="reports-heading my-5 p-3 d-flex flex-wrap">
                          {CollectionOutlet.title}
                          <span className="mx-2">|</span>
                          <span className="mx-2">
                            {CollectionOutlet.comp_title3}
                          </span>
                          <span className="mx-2">|</span>
                          {CollectionOutlet.comp_title4}
                          <span className="mx-2">|</span>
                        </h3>
                        <div className="row p-2">
                          <div className="col-lg-6 col-12">
                            <div className="row">
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Report Title</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {/* {CollectionOutlet?.report_title} */}{" "}
                                  Collection by Outlet
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">From Date</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.from_date}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Printed by</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.print_by}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Site</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.site}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="row ">
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Outlet</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.outlet}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">To Date</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.to_date}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Print Time</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.print_time}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          {siteNameKeys.map((siteName) => (
                            <div key={siteName}>
                              <div className="row mt-5">
                                <div className="col-6">
                                  {" "}
                                  <h6 className="px-2 my-3">
                                    Pay Date:{" "}
                                    {
                                      groupedData[siteName][
                                        Object.keys(groupedData[siteName])[0]
                                      ].items[0].payDate
                                    }
                                  </h6>
                                </div>
                                <div className="col-6">
                                  {" "}
                                  <h6 className="px-2 my-3">
                                    Outlet:{siteName}
                                  </h6>
                                </div>
                              </div>
                              {Object.keys(groupedData[siteName]).map(
                                (payType) => {
                                  const {
                                    items,
                                    totalAmt,
                                    totalTaxes,
                                    totalBankCharges,
                                    total,
                                  } = groupedData[siteName][payType];
                                  return (
                                    <div key={payType}>
                                      <h6 className="px-2  mt-4 mb-5">
                                        Pay Type:{payType}
                                      </h6>
                                      <NormalTable
                                        headerDetails={
                                          this.state.treatmentListHeader
                                        }
                                      >
                                        <thead>
                                          <tr>
                                            <th className="align-items-center justify-content-center">
                                              Issued by
                                            </th>
                                            <th className="align-items-center justify-content-center">
                                              Invoice Ref
                                            </th>
                                            <th className="align-items-center justify-content-center">
                                              Customer
                                            </th>
                                            <th className="align-items-center justify-content-center">
                                              Customer Ref.
                                            </th>
                                            <th className="text-center">
                                              Payment by others
                                            </th>
                                            <th className="text-center">
                                              TAXES
                                            </th>
                                            <th className="text-center">
                                              Bank charges
                                            </th>
                                            <th className="text-center">
                                              Receivables
                                            </th>
                                          </tr>
                                        </thead>
                                        <div>
                                          {items.map((item) => (
                                            <>
                                              <tr>
                                                <td key={item.sa_transacno}>
                                                  <div>{item.customer}</div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-left  text-lightblue fw-700">
                                                    <button
                                                      className="border-0 bg-white"
                                                      onClick={() =>
                                                        this.handleInvoiceRef(
                                                          item.sa_transacno
                                                        )
                                                      }
                                                    >
                                                      {" "}
                                                      {item.invoiceRef}
                                                    </button>
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-left  ">
                                                    {item.payRef}
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-left  ">
                                                    {item.CustRef}
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-center">
                                                    {item.amt}
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-center ">
                                                    {item.taxes}
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-center  ">
                                                    {item.BankCharges}
                                                  </div>
                                                </td>
                                                <td className="fs-16">
                                                  <div className="text-center ">
                                                    {item.total}
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          ))}
                                          <table className="table mb-0">
                                            <thead></thead>
                                            <tbody>
                                              <tr className="text-center">
                                                <td className="fw-700">
                                                  TOTAL
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>

                                                <td className="fw-700">
                                                  Cash Total
                                                </td>
                                                {items.length > 0 && (
                                                  <>
                                                    {/* <td>{items[0].payDate}</td> */}
                                                    <td className="fw-700 px-3 initial">
                                                      {totalAmt}
                                                    </td>
                                                    <td className="fw-700 px-3 initial">
                                                      {totalTaxes}
                                                    </td>
                                                    <td className="fw-700 px-3 initial">
                                                      {totalBankCharges}
                                                    </td>
                                                    <td className="fw-700 px-3 initial">
                                                      {total}
                                                    </td>
                                                  </>
                                                )}
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </NormalTable>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <td colSpan="8">
                <div class="d-flex mt-5 align-items-center justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCommonApi, commonCreateApi }, dispatch);
};

export const CollectionOutlet = withTranslation()(
  connect(null, mapDispatchToProps)(CollectionOutletClass)
);
